import { render, staticRenderFns } from "./PublicChoresScreen.vue?vue&type=template&id=b217ecd4&scoped=true"
import script from "./PublicChoresScreen.vue?vue&type=script&lang=js"
export * from "./PublicChoresScreen.vue?vue&type=script&lang=js"
import style0 from "./PublicChoresScreen.vue?vue&type=style&index=0&id=b217ecd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b217ecd4",
  null
  
)

export default component.exports